// extracted by mini-css-extract-plugin
module.exports = {"banner_wrapper":"Banner_banner_wrapper__mwsOZ","button":"Banner_button__WxpEs","subtitle":"Banner_subtitle__BwGqq","buttons":"Banner_buttons__30mzq"};